<template>
  <v-container fluid>
    <v-card dark color="transparent" width="100%" class="mx-auto mt-10" elevation="0">
      <v-card-title class="text-h5">Dashboard</v-card-title>
      
      <v-container fluid class="d-flex justify-center">
        <v-text-field v-model="search" prepend-icon="mdi-magnify" clearable label="Search" hide-details></v-text-field>
        <v-spacer />
      </v-container>

      <v-data-table :loading="get_data_load" :headers="headers" :items="ODP_data.Tubular" :search="search" class="elevation-1 custom-table" :footer-props="{'items-per-page-options':[5, 10, 50, 100, -1]}" :sort-by="'Priority.value'" :sort-desc="false"
      >
        <template v-slot:item.Priority.value="{ item }">
          <span v-if="item.Priority.color">{{ item.Priority.name }}</span>
        </template>
        
        <template v-slot:item.Return_Date.value="{ item }">
          <span v-if="item.Return_Date.value">{{ item.Return_Date.name }}</span>
        </template>

        <!-- Request Date  -->
        <template v-slot:item.RequestDate="{ item }">

          <div v-if="item.RequestDate && item.RequestDate !== null && item.RequestDate !== ''">
            <div class="d-flex align-center">
              <div class="mr-2">{{ formatDate(item.RequestDate) }}</div>

              <v-btn icon small class="ma-0 pa-0" @click.stop="openEdit(item)" title="Edit request date">
                <v-icon x-small>mdi-pencil</v-icon>
              </v-btn>

            </div>
          </div>

          <!-- Menu content -->
          <v-menu v-else v-model="item.popup" :close-on-content-click="false" transition="scale-transition" offset-y >
            <template #activator="{ on, attrs }">
              <v-btn color="btn-transparent" small v-bind="attrs" v-on="on" width="106px">Set Date</v-btn>
            </template>

            <v-card style="min-width: 300px;">
              <v-card-text>
                <v-text-field v-model="item.tempRequestDate" type="date" label="Request Date" hide-details></v-text-field>
                <v-textarea v-model="item.tempRequestDateComment" label="Comment" rows="2" auto-grow class="mt-2"></v-textarea>
              </v-card-text>

              <v-card-actions>
                <v-spacer />
                <v-btn elevation="3" text @click="cancelDateRequest(item)">Cancel</v-btn>
                <v-btn color="primary" @click="sendRequestedDates(item)" :loading="item.sending" :disabled="!item.tempRequestDate">
                  Send Request
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>

          <!-- Edit Menu -->
          <v-menu v-if="item.RequestDate" v-model="item.popup" :close-on-content-click="false" transition="scale-transition" offset-y>

            <template #activator="{ on, attrs }">
              <v-btn icon small v-bind="attrs" v-on="on" @click.stop="openEdit(item)" style="opacity:0; position:absolute; pointer-events:none;"></v-btn>
            </template>

            <v-card style="min-width: 300px;">
              <v-card-text>
                <v-text-field v-model="item.tempRequestDate" type="date" label="Request Date" hide-details></v-text-field>
                <v-textarea v-model="item.tempRequestDateComment" label="Comment" rows="2" auto-grow class="mt-2"></v-textarea>
              </v-card-text>

              <v-card-actions>
                <v-spacer />
                <v-btn elevation="3" text @click="cancelDateRequest(item)">Cancel</v-btn>
                <v-btn color="primary" @click="sendRequestedDates(item)" :loading="item.sending" :disabled="!item.tempRequestDate">
                  Update Request
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>

        </template>
      </v-data-table>
    </v-card>
  </v-container>
  
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex'

export default {
  name: 'Dashboard',
  data() {
    return {
      search: '',
      loading: false,
      headers: [
        { text: 'Priority', value: 'Priority.value' },
        { text: 'Order Number', value: 'Order_No' },
        { text: 'Request Date', value: 'RequestDate' },
        { text: 'Return Date', value: 'Return_Date.value' },
        { text: 'PO Number', value: 'PO' },
        { text: 'String No', value: 'String_No' },
        { text: 'Item No', value: 'Item_No' },
        { text: 'Equipment', value: 'Equipment' },
        { text: 'Quantity', value: 'QTY' },
        { text: 'Inspection', value: 'Inspection' },
        { text: 'Machining', value: 'Machining' },
        { text: 'Hardbanding', value: 'Hardbanding' },
        { text: 'Shipped', value: 'DT' }
      ],
      items: [],
      ODP_data: { Tubular: [], BHA: [] }
    }
  },
  methods: {
    formatDate(date) {
    if (!date) return '';
    const [year, month, day] = date.split('-');
    return `${day}.${month}.${year}`;
  },
    async sendRequestedDates(item) {
      if (!item.Order_No || !item.tempRequestDate) {
        console.log("Missing order number or request date for item:", item);
        return;
      }

      this.$set(item, 'sending', true);

      try {
        const res = await axios.post("updateRequestedDate", {
          order_no: item.Order_No,
          RequestDate: item.tempRequestDate,
          Comment: item.tempRequestDateComment || "",
          ItemNo: item.Item_No,
          username: this.$store.getters.getUsername
        });

        // Update the item with the values from temp fields
        this.$set(item, "RequestDate", item.tempRequestDate);
        this.$set(item, "Comment", item.tempRequestDateComment || "");
        
        // Close popup
        item.popup = false;
        item.dateConfirmed = true;

        // Clear temp values
        item.tempRequestDate = null;
        item.tempRequestDateComment = '';

      } catch (err) {
        console.error("Error saving request date:", err);
        item.popup = false;
        item.dateConfirmed = false;
      } finally {
        this.$set(item, 'sending', false);
      }
    },

    openEdit(item) {
      this.$set(item, 'tempRequestDate', item.RequestDate || null);
      this.$set(item, 'tempRequestDateComment', item.Comment || '');
      this.$set(item, 'sending', false);
      item.popup = true;
    },

    cancelDateRequest(item) {
      item.popup = false;
      item.tempRequestDate = null;
      item.tempRequestDateComment = '';
    }
  },
  computed: {
    ...mapGetters(['getUsername', 'getAsset', 'getFleet', 'get_data_load'])
  },
  mounted() {
    this.$initialDataLoad(this.$route.meta.backendRoutes, { username: this.$store.getters.getUsername })
  }
}
</script>

<style scoped>
.btn-transparent {
  background-color: transparent !important;
  color: white !important;
}

::v-deep .theme--dark.v-data-table {
  background-color: #1C355E;
}

::v-deep .v-data-table-header {
  background-color: rgba(255, 255, 255, 0.8);
}

::v-deep .theme--dark.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
  color: #1C355E;
}

::v-deep .custom-table thead th {
  background-color: rgba(255, 255, 255, 0.9);
}

::v-deep .custom-table thead th:first-child {
  border-radius: 10px 0 0 0;
}

::v-deep .custom-table thead th:last-child {
  border-radius: 0 10px 0 0;
}

::v-deep tbody tr:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

::v-deep .v-chip .v-chip__content {
  margin: auto;
}
</style>